import Modal from '@/Components/Modal';
import SecondaryButton from '@/Components/SecondaryButton';
import { useForm } from '@inertiajs/react';
import PrimaryButton from '@/Components/PrimaryButton';

import TextInput from '@/Components/Form/TextInput';

export default function DeleteBlogModal({
	blog,
	show,
	onClose
}) {
	const {
		data,
		setData,
		delete: destroy,
		processing,
		reset,
		errors
	} = useForm({
		confirm: ''
	});

	const deleteChampionship = (e) => {
		e.preventDefault();

		destroy(route('blogs.destroy', blog.id), {
			preserveScroll: true,
			onSuccess: onClose
		});
	};

	return (
		<Modal show={show} onClose={onClose}>
			<form
				onSubmit={deleteChampionship}
				className="p-6"
			>
				<h3 className="text-lg font-bold">
					Are you sure you want to delete this
					article?
				</h3>

				<p className="mb-4">
					Once this article is deleted, all of its
					resources and data will be permanently
					deleted. Please type 'delete' to confirm
					you would like to permanently delete
					this article.
				</p>

				<div className="flex flex-wrap">
					<TextInput
						name="confirm"
						errors={errors.confirm}
						classes="w-full"
						placeholder="Type 'delete'"
						onChange={(e) =>
							setData(
								'confirm',
								e.target.value
							)
						}
					/>
					{errors.confirm && (
						<div className="text-error text-xs">
							{errors.confirm}
						</div>
					)}
				</div>

				<div className="mt-6 flex justify-end">
					<SecondaryButton onClick={onClose}>
						Cancel
					</SecondaryButton>

					<PrimaryButton
						className="ml-3"
						processing={processing}
					>
						Delete
					</PrimaryButton>
				</div>
			</form>
		</Modal>
	);
}
